import { useContext, useMemo } from 'react'
import { FilterContext } from 'features/dashboard/filter/FilterContext'
import { batch, useDispatch, useSelector } from 'react-redux'
import NoneAnchor from 'components/NoneAnchor'
import Highlight from 'components/Highlight'
import { setFilters } from 'features/dashboard/filter/dashboardFilterSlice'
import { paramToFilter } from 'features/dashboard/utils/dashboardUtils'
import { campaignTableActions } from 'features/dashboard/table/campaign/campaignTableSlice'
import { adGroupTableActions } from 'features/dashboard/table/adGroup/adGroupTableSlice'
import { keywordTableActions } from 'features/dashboard/table/keyword/keywordTableSlice'
import { creativeTableActions } from 'features/dashboard/table/creative/creativeTableSlice'

const SavedFilterNames = () => {
  const dispatch = useDispatch()
  const { value, setValue, setMenuVisible } = useContext(FilterContext)
  const { savedFilters } = useSelector(state => state.dashboard.filter)
  const menus = useMemo(() => {
    if (value.trim() === '' || savedFilters.length === 0) {
      return []
    }
    return savedFilters.filter(({ name }) => name.includes(value))
  }, [value, savedFilters])
  return menus.length === 0 ? null : (
    <>
      <strong className="tit_lyadsearch">저장한 검색 조건</strong>
      <ul className="list_lyadsearch">
        {menus.map(({ id, name, filters }) => (
          <li key={id}>
            <NoneAnchor
              className="link_searchfilter"
              onClick={() => {
                setValue('')
                setMenuVisible(false)
                window.scrollTo({ top: 0 })
                const parsed = JSON.parse(filters)
                batch(() => {
                  dispatch(setFilters(paramToFilter(parsed)))
                  dispatch(campaignTableActions.setPage(0))
                  dispatch(adGroupTableActions.setPage(0))
                  dispatch(keywordTableActions.setPage(0))
                  dispatch(creativeTableActions.setPage(0))
                })
              }}>
              <Highlight match={value} string={name} />
            </NoneAnchor>
          </li>
        ))}
      </ul>
    </>
  )
}

export default SavedFilterNames
